export class LoginDto {
  email = '';
  password = '';
}
